module.exports = __webpack_public_path__ + "img/grandparents-grandkids-512x180-60.1dd23b74.jpg";